<template>
  <div class="dialog-margin">
    <div>
      <span>物品编号：{{ goodsNo }}</span>
    </div>
    <div>
      <el-table :data="batchArray">
        <el-table-column prop="batchNumSource" label="批次号" width="200"/>
        <el-table-column prop="mainQuantity" label="主数量"/>
        <el-table-column prop="slaveQuantity" label="副数量"/>
      </el-table>
      <div class="control-button padding-10">
        <el-button @click="close">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 批次号查看组件
 * @Author: 菩萨蛮
 * @Date: 2020/10/10 9:33 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'CheckBatchListDialog',
  props: {
    rowIndex: { type: Number, default: -1 },
    goodsNo: { type: String, default: '' },
    batchList: { type: Array }
  },
  data() {
    return {
      batchArray: []
    };
  },
  created() {
    this.setDefaultArray();
  },
  methods: {
    setDefaultArray() {
      this.batchArray = this.utils.copy(this.batchList);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
